// import { max, min } from 'd3-array';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { bandScale, ordinalScale } from '../../../factory/scales';

import data from './data/data.json';
// import { cnn_red } from './utils/colors';

export default function (props) {
  const { initialWidth, isMobile } = props;

  const margins = {
    top: 20,
    right: 30,
    bottom: 20,
    left: isMobile ? 150 : 150,
  };

  const barHeight = 15;
  const padding = 0.2;
  const keys = Object.keys(data[0]).slice(1);

  const width = initialWidth - margins.right - margins.left;
  const height = (data.length * keys.length) * (barHeight + (padding * barHeight));

  // const maxValue = max(data, d => max(keys, key => d[key]));
  // const minValue = min(data, d => min(keys, key => d[key]));

  const xAxisConfig = {
    orientation: 'bottom',
    domain: [-2000, 0],
    range: [0, width],
    // nice: true,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: data.map(d => d.Group),
    range: [0, height],
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y0 } = bandAxis(yAxisConfig);

  const y1 = bandScale({
    domain: keys,
    range: [0, y0.bandwidth()],
    padding,
  });

  const colorScale = ordinalScale({
    domain: keys,
    // range: ['#aaa', '#ff5137'],
    range: ['#ff5037', '#004969'],
  });

  return {
    colorScale,
    data,
    height,
    initialWidth,
    initialHeight: height + margins.top + margins.bottom,
    keys,
    margins,
    width,
    xAxis,
    x,
    yAxis,
    y0,
    y1,
  };
}
